const DeleteIcon = ({ color = "rgb(var(--color-danger))" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_13039_655)">
        <path
          d="M2 4.6H3.77778M3.77778 4.6H18M3.77778 4.6V17.2C3.77778 17.6774 3.96508 18.1352 4.29848 18.4728C4.63188 18.8104 5.08406 19 5.55556 19H14.4444C14.9159 19 15.3681 18.8104 15.7015 18.4728C16.0349 18.1352 16.2222 17.6774 16.2222 17.2V4.6M6.44444 4.6V2.8C6.44444 2.32261 6.63175 1.86477 6.96514 1.52721C7.29854 1.18964 7.75073 1 8.22222 1H11.7778C12.2493 1 12.7015 1.18964 13.0349 1.52721C13.3683 1.86477 13.5556 2.32261 13.5556 2.8V4.6M8.22222 9.1V14.5M11.7778 9.1V14.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_13039_655">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DeleteIcon;
